export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/LoginMethod.vue'),
        meta: {
          layout: 'full',
        },
      },
      {
        path: '/login_opt',
        name: 'login-opt',
        component: () => import('@/views/login/LoginOpt.vue'),
        meta: {
          layout: 'full',
        },
      },
]